/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Tab_Attention_AriaInputs */



/**
* | output |
* | --- |
* | "Attention needed" |
*
* @param {Sub_Tab_Attention_AriaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_tab_attention_aria = /** @type {((inputs?: Sub_Tab_Attention_AriaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Tab_Attention_AriaInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aufmerksamkeit erforderlich")
	return /** @type {LocalizedString} */ ("Attention needed")
});